import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { Mutation, MutationUpdateUserDetailsArgs } from '@/graphql/API';
import { updateUserDetails } from '@/graphql/mutations';
import type { UseMutationReturn } from '@vue/apollo-composable';

const document = gql(updateUserDetails);

type MutationResult = {
  updateUserDetails: Mutation['updateUserDetails'];
};

export function useUpdateUserDetails(): UseMutationReturn<
  MutationResult,
  MutationUpdateUserDetailsArgs
> {
  return useMutation<MutationResult, MutationUpdateUserDetailsArgs>(document);
}
